import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import { Star, BadgeCheck } from 'lucide-react';

import s from './FiveStarReviews.css';
import Avatar from '../../Avatar';
import Link from '../../Link';

// Locale
import messages from '../../../locale/messages';

class ReviewCard extends React.Component {
    static propTypes = {
        review: PropTypes.shape({
            id: PropTypes.number,
            reviewContent: PropTypes.string,
            rating: PropTypes.number,
            createdAt: PropTypes.string,
            authorData: PropTypes.object,
            listingData: PropTypes.object,
        }).isRequired,
        index: PropTypes.number,
    };

    state = {
        imageLoaded: false,
    };

    handleImageLoad = () => {
        this.setState({ imageLoaded: true });
    };

    // Truncate review content
    truncateText = (text, maxLength = 120) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength).trim() + '...';
    };

    // Get boat image URL
    getBoatImage = () => {
        const { review } = this.props;
        const { listingData } = review;

        if (listingData?.listPhotos?.[0]?.name) {
            return `/images/upload/x_medium_${listingData.listPhotos[0].name}`;
        }
        return '/images/placeholder-boat.jpg';
    };

    render() {
        const { review, intl } = this.props;
        const { imageLoaded } = this.state;
        const { formatMessage } = intl;
        const { authorData, listingData, reviewContent } = review;

        if (!authorData || !listingData) return null;

        return (
            <div className={s.reviewCard}>
                {/* Author Section */}
                <div className={s.authorSection}>
                    <Avatar
                        source={authorData.picture}
                        height={48}
                        width={48}
                        title={authorData.firstName}
                        className={s.authorAvatar}
                        withLink
                        profileId={authorData.profileId}
                    />
                    <div className={s.authorInfo}>
                        <span className={s.authorName}>
                            {authorData.firstName} {authorData.lastName?.charAt(0)}.
                        </span>
                        <div className={s.starsRow}>
                            {[1, 2, 3, 4, 5].map((star) => (
                                <Star
                                    key={star}
                                    size={14}
                                    className={s.starIcon}
                                    fill="#FFB800"
                                    stroke="#FFB800"
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Verified Badge */}
                <div className={s.verifiedBadge}>
                    <BadgeCheck size={14} />
                    <span>{formatMessage(messages.verifiedTrip)}</span>
                </div>

                {/* Review Content */}
                <p className={s.reviewContent}>
                    "{this.truncateText(reviewContent)}"
                </p>

                {/* Boat Section with Lazy Loading */}
                <Link to={`/boats/${listingData.id}`} className={s.boatSection}>
                    <div className={s.boatImageWrapper}>
                        <img
                            src={this.getBoatImage()}
                            alt={listingData.title}
                            loading="lazy"
                            decoding="async"
                            onLoad={this.handleImageLoad}
                            className={cx(s.boatImage, imageLoaded && s.imageLoaded)}
                        />
                        {!imageLoaded && <div className={s.imagePlaceholder} />}
                    </div>
                    <div className={s.boatInfo}>
                        <span className={s.boatTitle}>{listingData.title}</span>
                        {listingData.city && (
                            <span className={s.boatLocation}>{listingData.city}</span>
                        )}
                    </div>
                </Link>
            </div>
        );
    }
}

export default injectIntl(withStyles(s)(ReviewCard));
